import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "ambr \"バーチャルギャラリー\""
const scope = "VR空間体験設計・制作"
const str1 = "OculusGoで遊べる国産VRSNS「ambr」のための、主に写真展示を行うギャラリーを設計・制作した。"
const str2 = "初めてVRSNSに触れる人やライトに楽しみたい人など、より多くの人に身近に感じてもらいたいというambrの想いに対して、ここではわかりやすさ、ポップさ、誰もが思い浮かべる未来感を心がけた。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.ambr01.childImageSharp.original.src}
          pageimgw={data.ambr01.childImageSharp.original.width}
          pageimgh={data.ambr01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/ambr01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/ambr02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/ambr03.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  ambr01: file(relativePath: {eq: "ambr01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
